import { render, staticRenderFns } from "./MatriculationsByProgram.vue?vue&type=template&id=a510bc38&scoped=true"
import script from "./MatriculationsByProgram.vue?vue&type=script&lang=js"
export * from "./MatriculationsByProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510bc38",
  null
  
)

export default component.exports